import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialAwardState: IAwardState = {
  data: {
    award: [],
    meta: {},
  },
  deleteSuccess: false,
  loading: false,
  success: false,
}

export interface IAwardState {
  data?: {
    award?: []
    meta?: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IAwardState = initialAwardState,
  action: ActionWithPayload<IAwardState>
) => {
  switch (action.type) {
    case actionTypes.GET_AWARD_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_AWARD_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_AWARD_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_AWARD_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_AWARD_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_AWARD_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_AWARD_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_AWARD_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_AWARD_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_AWARD_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_AWARD_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_AWARD_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_AWARD_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_AWARD_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_AWARD_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_AWARD_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_AWARD_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_AWARD_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_AWARD_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SORT_AWARD_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_AWARD_SUCCESS: {
      return {
        ...state,
        sortAwardData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_AWARD_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_AWARD_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortAwardData: [],
      }
    }

    default:
      return state
  }
}
